import { useEffect, useState } from 'react'
import {
  fetchLegalEntities,
  LEGAL_ENTITIES_SNAPSHOT,
  resolveLegalEntity,
  type LegalEntitiesDocument,
  type LegalEntity,
} from '../utils/legalEntities'

// Lu une fois par session, partagé par les deux tunnels.
let published: Promise<LegalEntitiesDocument> | null = null

/** L'entité juridique d'une marque : le snapshot tout de suite, le fichier publié une fois lu. */
export function useLegalEntity(brand: string): LegalEntity {
  const [document, setDocument] = useState<LegalEntitiesDocument>(LEGAL_ENTITIES_SNAPSHOT)

  useEffect(() => {
    let active = true
    published ??= fetchLegalEntities(import.meta.env.VITE_ENV as string | undefined)
    // fetchLegalEntities ne rejette jamais : il retombe sur le snapshot.
    void published.then((loaded) => active && setDocument(loaded))
    return () => {
      active = false
    }
  }, [])

  return resolveLegalEntity(document, brand)
}
